<header class="card-head">
  <h2 class="card-title">Capital social</h2>
  @if (source(); as s) {
    <app-charter-provenance [from]="s" variant="source" [current]="true" />
  }
</header>

@if (capital().shareCapital.value !== null) {
  <p class="total prov-row">
    {{ total() }}
    <app-charter-provenance
      [from]="capital().shareCapital"
      [current]="true"
      variant="icon"
      [base]="source()" />
  </p>
} @else {
  <p class="total total--empty">Não informado no documento</p>
}

@if (unitsLine() || paidInLine()) {
  <p class="subline">
    {{ unitsLine() }}
    @if (unitsLine() && paidInLine()) {
      ·
    }
    {{ paidInLine() }}
  </p>
}

@if (classes().length > 0) {
  <ul class="classes">
    @for (shareClass of classes(); track shareClass.label) {
      <li class="classes__row prov-row">
        <span>
          {{ shareClass.label }}
          @if (shareClass.votingRight === false) {
            <small class="classes__hint">sem voto</small>
          }
        </span>
        <strong>
          {{ shareClass.units }}
          <app-charter-provenance [from]="shareClass.evidence" variant="icon" [base]="source()" />
        </strong>
      </li>
      @if (shareClass.preferences) {
        <li class="classes__pref">{{ shareClass.preferences }}</li>
      }
    }
  </ul>
}

@if (slices().length > 0) {
  <div class="bar" role="img" aria-label="Participação dos sócios no capital">
    @for (slice of slices(); track slice.name) {
      <span
        class="bar__slice"
        [style.width.%]="slice.percentage"
        [style.background]="slice.color"></span>
    }
  </div>
  <ul class="legend">
    @for (slice of slices(); track slice.name) {
      <li>
        <span class="legend__dot" [style.background]="slice.color"></span>
        {{ slice.name }} {{ formatPercent(slice.percentage) }}
      </li>
    }
  </ul>
}

@if (authorized(); as a) {
  <p class="authorized prov-row">
    Capital autorizado: {{ a.text }}
    <app-charter-provenance [from]="a.evidence" variant="icon" [base]="source()" />
  </p>
}

@if (history().length > 0) {
  <button
    type="button"
    class="link-btn"
    [attr.aria-expanded]="historyOpen()"
    (click)="historyOpen.set(!historyOpen())">
    <i
      class="pi"
      [class.pi-history]="!historyOpen()"
      [class.pi-chevron-up]="historyOpen()"
      aria-hidden="true"></i>
    {{ historyOpen() ? 'Fechar histórico' : 'Ver histórico do capital (' + history().length + ')' }}
  </button>
  @if (historyOpen()) {
    <app-charter-history-list
      class="history"
      [rows]="history()"
      [currentActId]="capital().shareCapital.actId"
      [label]="'Histórico do capital social'" />
  }
}
